<template>
  <div class="stats-builder-table">
    <CardApiError v-if="showRetry" @retry="setDataTable" />
    <Card v-else :is-loading="loading" no-padding>
      <TableWidget
        :columns="columns"
        :content="data"
        :default-sort="defaultSort"
      />
    </Card>
  </div>
</template>

<script>
import TableWidget from './TableWidget';
import CardApiError from '@@/common/CardApiError';
import Card from '@@/common/Card';
import { Insight } from '@/api/api';
import packageName from '@/mixins/packageName';
import { APP_DETAILS } from '@/store/types';

export default {
  name: 'StatsBuilderTables',
  components: {
    TableWidget,
    CardApiError,
    Card,
  },
  mixins: [packageName],
  props: {
    tag: {
      type: Object,
      required: true,
    },
    range: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      columns: [],
      data: [],
      loading: true,
      showRetry: false,
    };
  },
  computed: {
    app() {
      return this.$store.getters[APP_DETAILS];
    },
    defaultSort() {
      const sortedColumn = this.columns.find(col => col.isSorted);
      if (sortedColumn) {
        const { slug, defaultOrder } = sortedColumn;
        const order = defaultOrder === 'asc' ? 'ascending' : 'descending';
        return {
          prop: slug,
          order,
        };
      }
      return {};
    },
  },
  watch: {
    tag() {
      this.setDataTable();
    },
    range() {
      this.setDataTable();
    },
  },
  created() {
    this.setDataTable();
  },
  methods: {
    setDataTable() {
      this.loading = true;
      this.showRetry = false;
      return Insight.getTables({
        packageName: this.packageName,
        app: this.app,
        selectedFilters: {
          tag: this.tag,
          range: this.range,
        },
      })
        .then(({ columns, data }) => {
          columns[0].minWidth = '150';
          columns[columns.length - 1].minWidth = '130';
          this.columns = columns;
          this.data = data;
        })
        .catch(({ body: { message } } = {}) => {
          if (message) {
            this.$message.error(message);
          }
          this.showRetry = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.stats-builder-table {
  .with-pagination-api__pagination {
    margin: $global-margin !important;
  }
}
</style>
